<don-campaign-card
  *ngFor="let c of vms; trackBy: trackById"
  [campaign]="toCardVM(c)"
  (select)="onSelect($event)">
</don-campaign-card>
